module.exports = __webpack_public_path__ + "img/top_msg.b5329be2.png";